var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotorealistic3Drendering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 26.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.86,26.22c-.57-.19-.84-.51-.98-1.04-.81-3.12-1.35-3.61-4.48-4.17q-.5-.78-.21-1.65c.44-.41,1.02-.26,1.53-.4,1.74-.48,2.8-1.58,3.1-3.34.12-.72.16-1.4,1.04-1.62.61.03,1.01.34,1.07.97.28,2.8,1.98,4.03,4.53,4.21.7.6.73,1.15.11,1.8-1,.29-2.17.3-3.08,1.08-.81.7-1.3,1.56-1.45,2.62-.1.7-.16,1.44-1.19,1.56Zm.07-7.68c-.43.64-1.11.93-1.36,1.61.45.5.88.97,1.17,1.29.6-.51,1.12-.94,1.62-1.37-.48-.51-.92-.98-1.44-1.53Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.95,8.36c-.29-.09-.43-.26-.49-.53-.41-1.58-.68-1.83-2.26-2.11q-.25-.39-.11-.84c.22-.21.52-.13.78-.2.88-.24,1.42-.8,1.57-1.69.06-.37.08-.71.53-.82.31.02.51.17.54.49.14,1.41,1,2.04,2.29,2.13.35.3.37.58.06.91-.51.14-1.1.15-1.56.55-.41.35-.66.79-.73,1.32-.05.35-.08.73-.6.79Zm.03-3.88c-.22.33-.56.47-.69.81.23.25.45.49.59.65.3-.26.57-.48.82-.69-.24-.26-.46-.49-.73-.77Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.39.18h12.81c.52,1.2.41,2.26.11,3.55h-12.81c-.58-1.15-.43-2.22-.11-3.55Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.04,3.66c-1.48.35-2.53.49-3.6-.1-.42-1.06-.39-2.11,0-3.19,1.06-.57,2.13-.35,3.25-.2.85,1.08.41,2.23.35,3.48Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.83,21.78c-1.48.35-2.53.49-3.6-.1-.42-1.06-.39-2.11,0-3.19,1.06-.57,2.13-.35,3.25-.2.85,1.08.41,2.23.35,3.48Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.22,14.79c-6.96,7.13-14.77,10.13-23.91,9.47-7.5-.54-13.89-3.52-19.32-9.53,6.13-6.39,13.16-9.44,21.54-9.45,8.38,0,15.4,3.06,21.69,9.52Zm-16.03-.04c-.02-3.03-2.63-5.61-5.65-5.59-3.01.02-5.62,2.66-5.6,5.66.02,3.01,2.67,5.63,5.67,5.6,3.01-.03,5.61-2.66,5.58-5.67Zm3.28,4.09c2.69-1.22,4.96-2.2,6.86-4.09-2.05-1.74-4.1-3.06-6.89-3.8.83,2.66.72,5.04.04,7.89Zm-17.52.03c-1.4-2.91-.82-5.35-.47-8.1-2.54,1.17-4.82,2.07-6.57,4.05,1.86,1.83,4.01,2.86,7.04,4.05Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.91,13.08c1.1-.5,2.16-.4,3.28-.09.62,1.14.52,2.27.09,3.47-1.09.54-2.16.32-3.21.18-.74-1.26-.63-2.39-.16-3.57Z",
    fill: "#f8f8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotorealistic3Drendering);
export default __webpack_public_path__ + "static/media/Photorealistic 3D rendering.ddfe8a53143753352f03e719e5de2f78.svg";
export { ForwardRef as ReactComponent };